var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEther({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ether",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.257,
    height: 41.132,
    viewBox: "0 0 25.257 41.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M152.526,0l-.276.938v27.2l.276.275,12.625-7.462Z",
    transform: "translate(-139.901)",
    fill: "#4d4d4d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M12.625,0,0,20.948l12.625,7.463V0Z",
    fill: "#bcb6b6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M153.886,295.239l-.156.189v9.689l.156.453,12.632-17.79Z",
    transform: "translate(-141.261 -264.438)",
    fill: "#4d4d4d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M12.625,305.57V295.238L0,287.78Z",
    transform: "translate(0 -264.438)",
    fill: "#bcb6b6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M155.65,200.711l12.625-7.462L155.65,187.51Z",
    transform: "translate(-143.025 -172.301)",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M0,193.249l12.625,7.462v-13.2Z",
    transform: "translate(0 -172.301)",
    fill: "#4e4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEther);
export default __webpack_public_path__ + "static/media/ether.5d97194625378044d8ce669dc583a239.svg";
export { ForwardRef as ReactComponent };